import dayjs from 'utils/dayjs';
import _ from 'lodash';

/**
 * Returns the list of months in a year, from momentJS' locale data
 * @return {array} a list of {text, value} objects, where 'value' is the month's number
 */
export const getMonthsList = () =>
    dayjs
        .months()
        .map((month, index) => ({
            text: _.capitalize(month),
            value: index + 1,
        }));

/**
 * Returns the list of years in a given range
 * @param  {number} currentYear - the current year
 * @param  {number} beforeRange - the number of years before the currentYear the range should start at
 * @param  {number} afterRange - the number of years after the currentYear the range should end at
 * @return {array} a list of {text, value} objects
 */
export const getYearsList = (currentYear, beforeRange, afterRange) => {
    const minYear = currentYear - beforeRange;
    const maxYear = currentYear + afterRange;
    const years = [];
    for (let i = minYear; i <= maxYear; i += 1) {
        years.push({
            text: i.toString(),
            value: i,
        });
    }
    return years;
};
